import React from "react";
var CryptoJS = require("crypto-js")

export const encrypt = (data, key) => {
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key.split('').reverse().join('')).toString();
    
    return ciphertext;
}

export const decrypt = (ciphertext, key) => {
    var bytes = CryptoJS.AES.decrypt(ciphertext, key.split('').reverse().join(''));
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    
    return decryptedData;
}